import { Qcdefectdto } from "@gtpl/shared-models/production-management";
import { Inject, Injectable } from "@nestjs/common";
import { QcDefect } from "../qc-defect-entity";
import { QcdefectitemEntity } from "./qc-defect-items-entity";
import { QcDefectDto } from "./qc-defect.dto";
@Injectable()

export class QcDefectAdapter{
    public convertDtoToEntity(QcDefectDto:QcDefectDto, isUpdate: boolean = false ):QcDefect{
        const qcdefect = new QcDefect();    
        qcdefect.qcId=QcDefectDto.qcId;
        qcdefect.lotNumber=QcDefectDto.lotNumber;
        qcdefect.workstationId=QcDefectDto.workstationId;
        qcdefect.startTime=QcDefectDto.startTime;
        qcdefect.remarks=QcDefectDto.remarks;
        qcdefect.operationId=QcDefectDto.operationId;
        qcdefect.inspectedCount=QcDefectDto.inspectedCount;
        qcdefect.inspectedQuantity=QcDefectDto.inspectedQuantity;
        qcdefect.passedQuantity=QcDefectDto.passedQuantity;
        qcdefect.testResult=QcDefectDto.testResult;
        qcdefect.unitId=QcDefectDto.unitId;
        qcdefect.createdUser=QcDefectDto.createdUser;
        qcdefect.isActive=QcDefectDto.isActive==undefined?true:QcDefectDto.isActive;
        if (isUpdate) {
            qcdefect.updatedUser = QcDefectDto.updatedUser;
          } else {
            qcdefect.isActive = true;
            qcdefect.createdUser = QcDefectDto.createdUser;
          }
          const conItems: QcdefectitemEntity[]  = []; 
          for (const qcdefectitems of QcDefectDto.qcDefectItemDetails) {
              const itemsEntity: QcdefectitemEntity = new QcdefectitemEntity();
              if(!qcdefectitems.qcdefectitemId){
                qcdefect.createdUser = QcDefectDto.createdUser;
              }else{
                  itemsEntity.qcdefectitemId =qcdefectitems.qcdefectitemId;
                  qcdefect.updatedUser = QcDefectDto.updatedUser; 
              }
              itemsEntity.testResultId =qcdefectitems.testResultId;
              itemsEntity.rejectedQuantity=qcdefectitems.rejectedQuantity;
              conItems.push(itemsEntity);
          }
          qcdefect.qcdefectItems = conItems;
         return qcdefect;

    }
    public convertEntityToDto(qcdefectObject: QcDefect): QcDefectDto {
        const qcdefectDto= new QcDefectDto;
        qcdefectDto.qcId=qcdefectObject.qcId;
        qcdefectDto.lotNumber = qcdefectObject.lotNumber;
        qcdefectDto.workstationId=qcdefectObject.workstationId;
        qcdefectDto.startTime=qcdefectObject.startTime;
        qcdefectDto.remarks=qcdefectObject.remarks;
        qcdefectDto.isActive = qcdefectObject.isActive;
        qcdefectDto.createdAt = qcdefectObject.createdAt;
        qcdefectDto.updatedAt = qcdefectObject.updatedAt;
        qcdefectDto.createdUser = qcdefectObject.createdUser;
        qcdefectDto.updatedUser = qcdefectObject.updatedUser;
        qcdefectDto.versionFlag = qcdefectObject.versionFlag;
        qcdefectDto.operationId=qcdefectObject.operationId;
        qcdefectDto.inspectedCount=qcdefectObject.inspectedCount;
        qcdefectDto.inspectedQuantity=qcdefectObject.inspectedQuantity;
        qcdefectDto.passedQuantity=qcdefectObject.passedQuantity;
        qcdefectDto.testResult=qcdefectObject.testResult;
        qcdefectDto.unitId=qcdefectObject.unitId;
        qcdefectDto.createdUser=qcdefectObject.createdUser;
        return qcdefectDto;
      }
}
